module.exports = __webpack_public_path__ + "static/img/header1.6cb0495.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/header1.jpg
// module id = Diaq
// module chunks = 1